module.exports = __webpack_public_path__ + "media/images/lb/155-37849342c0b94db75dbfa5791ea19613.svg";